// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class TrafficWaitTimeListResponse implements flatbuffers.IUnpackableObject<TrafficWaitTimeListResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): TrafficWaitTimeListResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTrafficWaitTimeListResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: TrafficWaitTimeListResponse,
  ): TrafficWaitTimeListResponse {
    return (obj || new TrafficWaitTimeListResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsTrafficWaitTimeListResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: TrafficWaitTimeListResponse,
  ): TrafficWaitTimeListResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new TrafficWaitTimeListResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  date(): string;
  date(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  date(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  floor(): string;
  floor(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  floor(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  direction(): string;
  direction(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  direction(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  seconds(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  position(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startTrafficWaitTimeListResponse(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addDate(builder: flatbuffers.Builder, dateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, dateOffset, 0);
  }

  static addFloor(builder: flatbuffers.Builder, floorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, floorOffset, 0);
  }

  static addDirection(builder: flatbuffers.Builder, directionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, directionOffset, 0);
  }

  static addSeconds(builder: flatbuffers.Builder, seconds: number) {
    builder.addFieldInt32(3, seconds, 0);
  }

  static addPosition(builder: flatbuffers.Builder, position: number) {
    builder.addFieldInt16(4, position, 0);
  }

  static endTrafficWaitTimeListResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // date
    builder.requiredField(offset, 6); // floor
    builder.requiredField(offset, 8); // direction
    return offset;
  }

  static createTrafficWaitTimeListResponse(
    builder: flatbuffers.Builder,
    dateOffset: flatbuffers.Offset,
    floorOffset: flatbuffers.Offset,
    directionOffset: flatbuffers.Offset,
    seconds: number,
    position: number,
  ): flatbuffers.Offset {
    TrafficWaitTimeListResponse.startTrafficWaitTimeListResponse(builder);
    TrafficWaitTimeListResponse.addDate(builder, dateOffset);
    TrafficWaitTimeListResponse.addFloor(builder, floorOffset);
    TrafficWaitTimeListResponse.addDirection(builder, directionOffset);
    TrafficWaitTimeListResponse.addSeconds(builder, seconds);
    TrafficWaitTimeListResponse.addPosition(builder, position);
    return TrafficWaitTimeListResponse.endTrafficWaitTimeListResponse(builder);
  }

  unpack(): TrafficWaitTimeListResponseT {
    return new TrafficWaitTimeListResponseT(
      this.date(),
      this.floor(),
      this.direction(),
      this.seconds(),
      this.position(),
    );
  }

  unpackTo(_o: TrafficWaitTimeListResponseT): void {
    _o.date = this.date();
    _o.floor = this.floor();
    _o.direction = this.direction();
    _o.seconds = this.seconds();
    _o.position = this.position();
  }

  unpackFields(...fields: string[]): TrafficWaitTimeListResponseT {
    const t = new TrafficWaitTimeListResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("date")) {
      t.date = this.date();
    }
    if (fieldSet.has("floor")) {
      t.floor = this.floor();
    }
    if (fieldSet.has("direction")) {
      t.direction = this.direction();
    }
    if (fieldSet.has("seconds")) {
      t.seconds = this.seconds();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    return t;
  }
}

export class TrafficWaitTimeListResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public date: string | Uint8Array | null = null,
    public floor: string | Uint8Array | null = null,
    public direction: string | Uint8Array | null = null,
    public seconds: number = 0,
    public position: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.date === null || this.date === undefined) {
      throw new Error('Required field "date" is not set');
    }
    if (this.floor === null || this.floor === undefined) {
      throw new Error('Required field "floor" is not set');
    }
    if (this.direction === null || this.direction === undefined) {
      throw new Error('Required field "direction" is not set');
    }
    const date = this.date !== null ? builder.createString(this.date!) : 0;
    const floor = this.floor !== null ? builder.createString(this.floor!) : 0;
    const direction = this.direction !== null ? builder.createString(this.direction!) : 0;

    return TrafficWaitTimeListResponse.createTrafficWaitTimeListResponse(
      builder,
      date,
      floor,
      direction,
      this.seconds,
      this.position,
    );
  }

  clone(): TrafficWaitTimeListResponseT {
    const obj = new TrafficWaitTimeListResponseT();
    obj.date = this.date;
    obj.floor = this.floor;
    obj.direction = this.direction;
    obj.seconds = this.seconds;
    obj.position = this.position;
    return obj;
  }

  equals(other: TrafficWaitTimeListResponseT): boolean {
    if (this.date !== other.date) return false;
    if (this.floor !== other.floor) return false;
    if (this.direction !== other.direction) return false;
    if (this.seconds !== other.seconds) return false;
    if (this.position !== other.position) return false;
    return true;
  }
}

export function verifyTrafficWaitTimeListResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "date");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "floor");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "direction");
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 2);
  } finally {
    verifier.popDepth();
  }
}
